<template>
	<div class="overflow-auto w-full">
		<article class="table w-full">
			<div
				v-for="(line, lineIdx) in hunk.lines"
				:key="lineIdx"
				class="line-container px-1 cursor-pointer"
				:class="[{ 'select-none': shiftClicking }, classForLine({ line, lineIdx })]"
				@click="$store.dispatch('onClickLine', { $event, fileName, hunkIdx, lineIdx })"
			>
				<pre class="text-gray-700 index-cell" :class="{ invisible: line.startsWith('+') }">{{ lineNumberToDisplay(hunk, lineIdx, false) }}</pre>
				<pre class="text-gray-700 index-cell" :class="{ invisible: line.startsWith('-') }">{{ lineNumberToDisplay(hunk, lineIdx, true) }}</pre>
				<pre class="line-cell">{{ line }}</pre>
			</div>
		</article>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	props: ['fileName', 'hunkIdx', 'hunk', 'shiftClicking'],
	computed: {
		...mapState(['linesSelected', 'linesSelectedMetadata']),
	},
	methods: {
		lineNumberToDisplay(hunk, lineIdx, isAdded) {
			let toDisplay = isAdded ? hunk.lineStartB : hunk.lineStartA;
			for (let i = 1; i <= lineIdx; i++) {
				if (hunk.lines[i].startsWith('-')) {
					if (isAdded) {
						// ignore
					} else {
						toDisplay++;
					}
				} else if (hunk.lines[i].startsWith('+')) {
					if (isAdded) {
						toDisplay++;
					} else {
						// ignore
					}
				} else {
					toDisplay++;
				}
			}
			return toDisplay;
		},
		lineSelected(lineIdx) {
			return this.linesSelected.includes(lineIdx) && this.linesSelectedMetadata.fileName === this.fileName && this.linesSelectedMetadata.hunkIdx === this.hunkIdx;
		},
		classForLine({ line, lineIdx }) {
			if (this.lineSelected(lineIdx)) return 'selected';
			else if (line.startsWith('+')) return 'added';
			else if (line.startsWith('-')) return 'removed';
			else return null;
		},
	},
};
</script>

<style lang="postcss">
.line-container {
	display: table-row;
	min-width: 100%;
	white-space: nowrap;

	.index-cell {
		width: 3rem;
	}
	.index-cell,
	.line-cell {
		display: inline-block;
	}

	@apply text-gray-500;
	&.added {
		@apply bg-green-200 text-green-900;
	}
	&.removed {
		@apply bg-red-200 text-red-900;
	}
	&.selected {
		@apply bg-yellow-300 text-yellow-900;
	}

	&:hover {
		@apply bg-gray-200 text-gray-700;

		&.added {
			@apply bg-green-300 text-green-900;
		}
		&.removed {
			@apply bg-red-300 text-red-900;
		}
		&.selected {
			@apply bg-yellow-300 text-yellow-900;
		}
	}
}
</style>
